import "../../../styles/index.css"
import "./AccordionFiltros.css"
import Accordion from "@mui/material/Accordion"
import AccordionSummary from "@mui/material/AccordionSummary"
import AccordionDetails from "@mui/material/AccordionDetails"
import Checkbox from "@mui/material/Checkbox"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { useState, useRef, useEffect } from "react"
import { useSearchParams } from "react-router-dom"

function AccordionFiltros({ titulo, arrayProps, filterKey, filtrosSelecionados }) {
	const [searchParams, setSearchParams] = useSearchParams()
	const [isChecked, setIsChecked] = useState(
		new Array(arrayProps.length).fill(false)
	)

	const isCheckedRef = useRef(isChecked)

	useEffect(() => {
		setIsChecked(new Array(arrayProps.length).fill(false))
		isCheckedRef.current = new Array(arrayProps.length).fill(false)

		if (filtrosSelecionados[filterKey]) {
			filtrosSelecionados[filterKey].forEach((value) => {
				const index = arrayProps.indexOf(value)
				isCheckedRef.current[index] = true
			})

			setIsChecked([...isCheckedRef.current])
		}
	}, [filtrosSelecionados, searchParams])

	useEffect(() => {
		isCheckedRef.current = isChecked
	}, [isChecked])

	const handleChange = (event, index) => {
		isCheckedRef.current[index] = event.target.checked
		setIsChecked([...isCheckedRef.current])

		if (isChecked[index]) {
			if (filtrosSelecionados[filterKey]) {
				filtrosSelecionados[filterKey].push(arrayProps[index])
			} else {
				filtrosSelecionados[filterKey] = [arrayProps[index]]
			}
		} else {
			filtrosSelecionados[filterKey] = filtrosSelecionados[filterKey].filter(
				(value) => value !== arrayProps[index]
			)
		}
	}

	return (
		<Accordion>
			<AccordionSummary
				expandIcon={<ExpandMoreIcon />}
				aria-controls="panel1a-content"
				id="panel1a-header"
			>
				<p className="s1 negrito">{titulo}</p>
			</AccordionSummary>
			<AccordionDetails>
				{arrayProps &&
					arrayProps.map((value, index) => (
						<div key={index} className="checkAttr">
							<Checkbox
								checked={isChecked[index]}
								onChange={(event) => handleChange(event, index)}
								inputProps={{ "aria-label": "controlled" }}
								sx={{
									color: "#A80A01",
									"&.Mui-checked": {
										color: "#A80A01",
									},
								}}
							/>

							<p className="bt2">{value}</p>
						</div>
					))}
			</AccordionDetails>
		</Accordion>
	)
}

export default AccordionFiltros
